// @file Types for presentation modes (Slideshow, Virtual Field Trip)

export type PresentationMode = 'slideshow' | 'field-trip'

export enum PresentationPageType {
  Cover = 'cover',
  Section = 'section',
  Group = 'group',
  Wish = 'wish',
}

type CoverPage = { pageType: PresentationPageType.Cover }
type SectionPage = {
  pageType: PresentationPageType.Section
  sectionId: number | string
}
type GroupPage = {
  pageType: PresentationPageType.Group
  groupId: number | string
}
type WishPage = {
  pageType: PresentationPageType.Wish
  wishId: number | string
}

export type PresentationPage = CoverPage | SectionPage | GroupPage | WishPage
